/* Component Dependencies */
var topicInfoFormTemplate = require('templates/topicInfoForm.hbs');
var AriesComponent = require('libs/aries-component');
var ResponsiveUtils = require('utils/responsiveUtils');
var DateHandler = require('libs/date-handler');
var $ = require('jquery');
var PubSub = require('libs/pub-sub');
var PUBSUB_PREFIX = 'TOGGLE_VISIBLE_';

AriesComponent.create({
  type: 'topicInfo',

  template: {
    'topicInfoForm': topicInfoFormTemplate
  },

  subscribe: {
    'CONTACT_US_CLEAR_FORM': 'clearButtonRefresh'
  },

  bindEvents: function () {
    var _self = this;
    var topicId = '#' + this.$el.data('topic-id');
    // Trigger the global event and then bind
    window.$(_self.$el[0]).on('change', _self.onTopicSelected.bind(_self));
    window.$(_self.$el.find(topicId)[0].form).on('reset', _self.onFormRest.bind(_self));

    this.options = {
      topics: this.$el.data('topics')
    }
    this.topicCodeSelected = this.$el.find(topicId).val()
    window.$(document).ready(function() {
      _self.showFormFor(_self.$el.find(topicId).val());
    });
  },

  unBindEvents: function ($) {
    window.$(this.$el[0]).off('click');
  },

  onFormRest: function() {
    this.$el.find('input').each(function(index, input) {
      $(input).attr('value', '');
      input.value = "";
      input.readOnly = false;
    });
  },

  onTopicSelected: function(evt) {
    // Caching topic IDs for which subtopic component need to refresh and fetch data
    var subTopicRefreshList = ['CCAPHS'];
    var showHotelWebsiteButton = this.$el.data('hwsButtonFlag');
   
    if (evt.target && "topic" !== evt.target.name) {
      this.onFormRest();
      return;
    }

    this.topicCodeSelected = evt.target.value;
    var topicCode = this.topicCodeSelected;
    if (subTopicRefreshList.includes(topicCode)) {
      this.pubsub.publish('FETCH_DATA_SUBTOPIC', [topicCode]);
    }
    if (showHotelWebsiteButton == true) {
      this.pubsub.publish('HIDE_HWS_BUTTON');
    }
      this.showFormFor(topicCode);
  },

  showFormFor: function(topicCode, isReloadingRequired = true, isTabFocus = false) {
  
    var toHide = this.$el.data('tilesList');
    var forms = this.options.topics[topicCode];
    var formsToShow = [];
    var subTopicRefreshListArr = ['MRMAP', 'MS'];
    var showHotelWebsiteButton = this.$el.find('input[name=showHotelWebsiteButton]').val();
    var DataForShow = {
      visible: true, 
      selectedTopic:topicCode,
      version: ''
    };
    var DataForHide = {
      visible: false,
      version: ''
    };
    var refreshFlag = this.$el.data('refreshFlag');
    var clearSessionUrl = this.$el.data('clearSession');

    if(refreshFlag && event != undefined ) {
      var data = {
        "sessionToken": this.getSessionToken(),
        "topic": topicCode
      };
      this.makeAjaxCall({
        url: clearSessionUrl,
        method: 'POST',
        data: JSON.stringify(data),
        success : function(data) {
          isReloadingRequired && window.location.reload();
        },
        error: function() {
          return false;
        }
      });
    }
    else {
      if (!topicCode) {
        for(var idx = 0; idx < toHide.length; idx++) {
          this.pubsub.publish(PUBSUB_PREFIX + toHide[idx], [DataForHide]);
        }
        this.pubsub.publish('HIDE_HWS_BUTTON');
      }
  
      for(var idx = 0; idx < toHide.length; idx++) {
        this.pubsub.publish(PUBSUB_PREFIX + toHide[idx], [DataForHide]);
      }
      if (subTopicRefreshListArr.includes(topicCode)) {
        this.pubsub.publish('FETCH_DATA_SUBTOPIC', [topicCode]);
      }
  
      this.pubsub.publish('UPDATE_COMMENT_HELPTEXT', ['']);
  
      if ( forms ) {
        for(formName in forms) {
          if(forms[formName].visible === true) {
            formsToShow.push(formName);
            if(forms[formName].templateName) {
              DataForShow.version = forms[formName].templateName
            }
          }
        }
        if (showHotelWebsiteButton == true) {
          this.pubsub.publish('HIDE_HWS_BUTTON');
        }
        for(var idx = 0; idx < formsToShow.length; idx++) {
          this.pubsub.publish(PUBSUB_PREFIX + formsToShow[idx], [DataForShow]);
        }
      }
      isTabFocus && this.$el.find("#topic").focus();
    }
  },

  clearButtonRefresh: function() {
    var topicCodeSelected = this.topicCodeSelected;
    var isRefresh = this.$el.data('refreshFlag');
    var isReloadingRequired;
    if (isRefresh) {
      var topicId = '#' + this.$el.data('topic-id');
      topicCodeSelected = this.$el.find(topicId).val();
      isReloadingRequired = false;
    }
    this.pubsub.publish('PREVENT_CLEAR_AFTER_SUBMIT', [isRefresh]);
    this.showFormFor(topicCodeSelected, isReloadingRequired, true);
  }

});
